import { render, staticRenderFns } from "./AC-AccountingVoucher.vue?vue&type=template&id=1c6672be&scoped=true&"
import script from "./AC-AccountingVoucher.vue?vue&type=script&lang=js&"
export * from "./AC-AccountingVoucher.vue?vue&type=script&lang=js&"
import style0 from "./AC-AccountingVoucher.vue?vue&type=style&index=0&id=1c6672be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6672be",
  null
  
)

export default component.exports